import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button } from "primereact/button"

export const defaultItemTemplate = (option: $TSMigrationFixMe) => {
  return <div>{option.label}</div>
}

export const defaultSelectedItemTemplate = (
  option: $TSMigrationFixMe,
  remove: $TSMigrationFixMe
) => {
  if (option) {
    return (
      <div
        className='multiselect-item-value'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='mr-2 my-auto'>{option.label}</div>
        <FontAwesomeIcon
          icon={["fal", "xmark"]}
          className='my-auto pointer'
          onClick={() => remove(option.label)}
        />
      </div>
    )
  }
  // TODO: i18n
  return <div className='multiselect-no-items'>Seleccione una etiqueta</div>
}
export const defaultPanelFooterTemplate = (
  openCreateModal: $TSMigrationFixMe
) => {
  return (
    <Button
      className='text'
      onClick={openCreateModal}
    >
      <FontAwesomeIcon
        icon={["fal", "plus"]}
        className='mr-2'
      />{" "}
      Añadir nueva etiqueta
    </Button>
  )
}
